import { useEffect } from 'react';

import { useOnboardingState } from 'entities/onboarding/api/useOnboardingState';
import { useOnboardingDialogStore } from 'features/onboarding/lib/useOnboardingDialogStore';

const OPEN_CLASS = 'assistant-panel-open';

/**
 * Reserve page width for the docked assistant panel while it is open.
 *
 * The class goes on the document element rather than a wrapper because the page banners are
 * `position: fixed` siblings of the content column, so both have to read the same custom property.
 * Whether the reservation applies at all is a media query's call in `app/styles/style.css`.
 */
export function useAssistantPanelReservation({ enabled }: { enabled: boolean }): void {
  const isOpen = useOnboardingDialogStore((state) => state.isOpen);
  const { data: onboardingState } = useOnboardingState({ enabled });
  // Released the moment the panel starts leaving, so the page widens on the same beat.
  const isReserved = enabled && isOpen && onboardingState?.layout === 'docked';

  useEffect(() => {
    if (!isReserved) {
      return;
    }
    document.documentElement.classList.add(OPEN_CLASS);
    return () => document.documentElement.classList.remove(OPEN_CLASS);
  }, [isReserved]);
}
